


















import { defineComponent, ref } from 'vue';
import { labelWatcherProps, useLabelWatcher } from '@/vuejs/composables/useLabelWatcher';
import type { UseLabelWatcherProps } from '@/vuejs/composables/useLabelWatcher';

const ARROW_OFFSET = 10;
const ARROW_HEIGHT = 30;
const ARROW_WIDTH = 30;

const POINTS = `
  ${ARROW_OFFSET},${ARROW_HEIGHT}
  ${ARROW_OFFSET + ARROW_WIDTH},${0}
  ${ARROW_OFFSET},${-ARROW_HEIGHT}
`;

export default defineComponent({
  name: 'SelectionArrows',
  props: { ...labelWatcherProps },
  setup(props) {
    const { rects, isMomentBar, classes } = useLabelWatcher(props as UseLabelWatcherProps);

    function getTransformRight(): string {
      const lastRectsIndex = rects.value.length - 1;
      const x = rects.value[lastRectsIndex].x + rects.value[lastRectsIndex].width;
      const y = rects.value[lastRectsIndex].y + rects.value[lastRectsIndex].height / 2;
      return `translate(${x} ${y})`;
    }

    function getTransformLeft(): string {
      const { x } = rects.value[0];
      const y = rects.value[0].y + rects.value[0].height / 2;
      return `translate(${x} ${y}) scale(-1 1)`;
    }

    const points = ref(POINTS);

    return {
      rects,
      isMomentBar,
      classes,
      getTransformRight,
      getTransformLeft,
      points,
    };
  },
});

